import { pxToRem } from '@modernhealth/vital-components';
import styled from '@emotion/styled';
import React from 'react';

import { useTranslation } from 'react-i18next';
import thanksPerson from 'src/public/img/thanks-person.svg';
import { Button } from 'src/shared/components/Button';
import { Modal } from 'src/shared/components/Modal';
import { color, font } from 'src/shared/styles/variables';

const StyledModal = styled(Modal)({
    '& .ant-modal-content': {
        maxWidth: pxToRem(500),
        minHeight: pxToRem(300),
        margin: '0 auto',
        borderRadius: pxToRem(20),

        '& .ant-modal-body': {
            padding: pxToRem(24),
        },
    },
});

const ModalHeader = styled('h3')(
    {
        color: color.ebonyClay,
        textAlign: 'left',
        marginBottom: pxToRem(16),
    },
    font.heavy(font.size.largeExtended),
);

const SubHeader = styled.p({
    color: color.blueBayoux,
    ...font.medium(font.size.medium),
    marginBottom: pxToRem(24),
});

interface StyledIconProps {
    iconUrl: string;
}

const StyledIcon = styled('i')<StyledIconProps>(({ iconUrl }) => ({
    display: 'inline-block',
    backgroundImage: `url('${iconUrl}')`,
    width: 220,
    height: 220,
    backgroundSize: 'cover',
    backgroundPositionX: 'center',
    margin: '0 auto',
    alignSelf: 'center',
    marginBottom: 20,
}));

interface Props {
    visible: boolean;
    onSubmit: () => void;
}

export enum DemographicFeedbackThanksModalTestID {
    Button = 'DemographicFeedbackThanksModalTestID.Button',
}

export const DemographicFeedbackThanksModal: React.FC<Props> = ({ visible, onSubmit }) => {
    const { t } = useTranslation();

    return (
        <React.Fragment>
            <StyledModal
                visible={visible}
                footer={null}
                width="auto"
                maskClosable={false}
                closable={false}
            >
                <div style={{ display: 'flex', justifyContent: 'center' }}>
                    <StyledIcon iconUrl={thanksPerson} />
                </div>
                <ModalHeader>{t('providers:demographic_feedback_thanks_modal.header')}</ModalHeader>
                <SubHeader>{t('providers:demographic_feedback_thanks_modal.sub_header')}</SubHeader>

                <Button
                    testID={DemographicFeedbackThanksModalTestID.Button}
                    type="accept"
                    onClick={onSubmit}
                    fullWidth
                >
                    {t('providers:demographic_feedback_thanks_modal.button.submit')}
                </Button>
            </StyledModal>
        </React.Fragment>
    );
};
